export default __webpack_public_path__ + "7cd338ca9f53d3b044e65237522e4f33.svg";